/* tslint:disable */
/* eslint-disable */
export enum WorkTicketChannelEnum {
  App = 'APP',
  Website = 'WEBSITE',
  Phone = 'PHONE',
  Email = 'EMAIL',
  Employee = 'EMPLOYEE',
  Other = 'OTHER'
}
